import { cookies } from "@utils/cookies";

export class DisclaimerPopup {
  private el: HTMLElement;
  private cookieName: string;
  private cookieExpiration: number;
  private content: HTMLElement | null;
  private yesButton: HTMLAnchorElement | null;
  private noButton: HTMLAnchorElement | null;

  constructor(el: HTMLElement) {
    this.el = el;
    this.cookieName = el.dataset.cookieName || "dentalprofessional";
    const expiration = Number(el.dataset.cookieExpiration);
    this.cookieExpiration = Number.isFinite(expiration) ? expiration : 1;

    this.content = document.getElementById("disclaimer-popup");

    this.yesButton = this.content
      ?.querySelector('.comp-button a[href=""], .comp-button a[href="#"]') || null;
    this.noButton = this.content
      ?.querySelector('.comp-button a[href]:not([href=""]):not([href="#"])') || null;

  }

  init(): void {
    if (!cookies.has(this.cookieName)) {
      this.openDisclaimerPopup();
    }
  }

  private removeEventListeners() {
    this.yesButton?.removeEventListener("click", this.onYesClick);
    this.noButton?.removeEventListener("click", this.onNoClick);
  }

  private onYesClick(event: Event): void {
    cookies.set(this.cookieName, "true", { days: this.cookieExpiration });
    window.Lightbox?.closeModal();
    this.removeEventListeners();
    event.preventDefault();
  }

  private onNoClick(): void {
    cookies.remove(this.cookieName);
    this.removeEventListeners();
  }

  private openDisclaimerPopup(): void {
    if (!this.content) return;
    
    window.Lightbox?.openModal(this.content, {}, true);

    this.yesButton?.addEventListener("click", (event: MouseEvent) => this.onYesClick(event));
    this.noButton?.addEventListener("click", () => this.onNoClick());
  }

  destroy(): void {
    this.removeEventListeners();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="disclaimer-popup"]')
      .forEach((el) => {
        new DisclaimerPopup(el).init();
      });
  }
}
